import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { IRemisionFilters } from "src/types/molecules";

/**
 * Filters for the Remisiones list. Unlike ReceiptFilters (recibos) there is no
 * "En mora" filter — remisiones have no overdue concept — and the state filter
 * lists the real RemisionState lifecycle values.
 */
const RemisionFilters = ({
  handleStatusFilter
}: IRemisionFilters) => {
  return <FormControl variant="outlined" sx={{
    minWidth: 140
  }}>
      <InputLabel id={"stateLabel"}>Estado</InputLabel>
      <Select labelId={"stateLabel"} label="Estado" defaultValue={""} sx={{
      width: 160
    }} onChange={e => handleStatusFilter(e.target.value)}>
        <MenuItem value={""}>
          <em>Todos</em>
        </MenuItem>
        <MenuItem value={"Creado"}>Creado</MenuItem>
        <MenuItem value={"Pagado"}>Pagado</MenuItem>
        <MenuItem value={"Aprobado"}>Aprobado</MenuItem>
        <MenuItem value={"Despachado"}>Despachado</MenuItem>
        <MenuItem value={"Cerrado"}>Cerrado</MenuItem>
      </Select>
    </FormControl>;
};
export default RemisionFilters;